export enum FinancialState {
  PENDING = 0,
  APROVE = 1,
  REJECT = 2,
  PAY = 3,
}

export enum FinancialMovementType {
  FACTURA = 'FACTURA',
  GASTO = 'GASTO',
  MOVIMIENTO = 'MOVIMIENTO',
}

export enum FinancialDocumentType {
  PNG = 'image/png',
  PDF = 'application/pdf',
  JPEG = 'image/jpeg',
}

export enum Company {
  ZGAMES = 'ZGAMES',
  SORTI = 'SORTI',
}
